// Removed the PLACEHOLDER import as we'll use URLs now
import blog2 from "../assets/blog2.jpg";
import blog3 from "../assets/blog3.jpg";
import blog4 from "../assets/blog4.jpg";
import canada from "../assets/Flag_map_of_Canada.svg"
import ont_que from "../assets/ont_que.webp"
import canadatrain from "../assets/canadatrain.jpg"
import customerServiceTraining from "../assets/DSC01562.jpeg"
import classroomTools from "../assets/learnpic1.jpg"
import workforceSafer from "../assets/2D5AF84B-BCE5-4DE9-AC05-06BE3908C967.jpeg"

import f1Crescent from "../assets/IMG_0557.jpeg"
import docuCriminals from "../assets/IMG_0556.jpeg"
import squattersIntervention from "../assets/IMG_0552.jpeg"
import bombThreatPrep from "../assets/PHOTO-144.jpeg"
import fireSaved from "../assets/IMG_6842.jpeg"
import iglofestCrowd from "../assets/IMG_0553.jpeg"

export const BLOG_DATA = {
  "foundation": {
    slug: "foundation",
    hero: {
      bgImage: "https://placehold.co/1200x600/e2e8f0/334155?text=Vision+Foundation+Community", // Replaced PLACEHOLDER
      imagePosition: "center",
      bgSize: "cover",
      kicker: "Community • Service • Dignity",
      title: "More Than Security: How the Vision Foundation Gives Back",
      subtitle:
        "Real help, real people, real impact — one person, one family, one community at a time.",
      dateISO: "2025-10-13",
      readTimeMin: 7,
      tags: ["Foundation", "Philanthropy", "Community"],
      author: {
        name: "Vision Foundation Team",
        avatar: "https://placehold.co/100x100/3244ba/ffffff?text=VF", // Use existing path or replace if it was also a placeholder
      },
    },
    lead: {
      eyebrow: "About the Vision Foundation",
      title: "Doing good, together",
      accent: "good",
      copy:
        "The Vision Foundation brings our community together to do good in tangible, personal ways—donating time, effort, and belongings instead of focusing on fundraising. We aim to spark generosity, build trust, and create meaningful moments of service that scale as our community grows.",
    },
    blocks: [
      {
        quote:
          "I believe there is no greater purpose in life than to do good for others. I started this company to create jobs and to be a positive force in the world. The Vision Foundation allows me to bring others along with me and spread the positive values I feel our world today is missing so much of.",
        cite: "Maximus Trinchini",
        image: "https://placehold.co/600x400/cbd5e1/1e293b?text=Maximus+T.", // Replaced PLACEHOLDER
        imageAlt: "Maximus Trinchini",
      },
      {
        quote:
          "The reality is, not everyone starts from the same place in life. Some people face barriers that others never even know exist. Everyone talks about inequality, but most people just complain or write checks and hope someone else fixes it. We actually show up. Through the Foundation, we're not just giving out clothes or food; we're putting resources directly in people's hands and creating moments where those barriers come down. When someone doesn't have to worry about their next meal or staying warm, that's when they can focus on building something better for themselves. That's how real change starts: one person, one family, one community at a time.",
        cite: "Christophe Lavoie",
        image: "https://placehold.co/600x400/cbd5e1/1e293b?text=Christophe+L.", // Replaced PLACEHOLDER
        imageAlt: "Christophe Lavoie",
        flip: true,
      },
      {
        quote:
          "I joined the foundation because I believe hope isn’t something people should search for alone, but something we can give each other.",
        cite: "Kevin Wilson",
        image: "https://placehold.co/600x400/cbd5e1/1e293b?text=Kevin+W.", // Replaced PLACEHOLDER
        imageAlt: "Kevin Wilson",
      },
      {
        eyebrow: "Why we serve",
        title: "Personal, authentic, and rewarding",
        accent: "authentic",
        copy:
          "Instead of fundraising, we emphasize donating time and essentials. That hands-on approach builds trust and makes giving feel direct and meaningful. As we grow, we’ll scale with people who share the same values—so growth stays human and grounded.",
        image: "https://placehold.co/600x400/e0f2fe/0c4a6e?text=Volunteers+Organizing", // Replaced PLACEHOLDER
        imageAlt: "Volunteers organizing donated items",
        flip: true,
      },
      {
        eyebrow: "Our current mission",
        title: "Essentials that restore dignity",
        accent: "Essentials",
        copy:
          "We focus on real needs people face today. Delivering these items directly—to institutions and individuals—brings immediate relief and connection.",
        points: [
          "Clothes — warmth and comfort, especially through harsh winters.",
          "Books — knowledge, learning, and inspiration for all ages.",
          "Food — peace of mind, even if it’s just for a single day.",
        ],
        image: "https://placehold.co/600x400/dcfce7/166534?text=Essentials+Donated", // Replaced PLACEHOLDER
        imageAlt: "Essentials: clothes, books, and food",
      },
      {
        eyebrow: "How we give",
        title: "Show up. Give directly. See the impact.",
        accent: "directly",
        copy:
          "Many donors don’t know where their money goes. We do things differently: we invite donors to join us in person to hand out donations. Seeing gratitude firsthand creates a powerful bond—and that’s what we plan to scale.",
        image: "https://placehold.co/600x400/f3e8ff/581c87?text=Direct+Giving", // Replaced PLACEHOLDER
        imageAlt: "Hand-to-hand donations",
        buttons: [
          { label: "Join our next drop-off", href: "/contact" },
          { label: "Become a community partner", href: "/contact" },
        ],
        flip: true,
      },
      {
        eyebrow: "Organizations we support",
        title: "Proud to stand with our community",
        accent: "community",
        copy:
          "We donate regularly to organizations doing vital work. We’re grateful to learn from and serve alongside them.",
        points: [
          "Ricochet",
          "Porte Ouverte",
          "Old Brewery Mission",
          "Résilience Montréal",
          "On Rock Community Services",
          "Maison Benoît Labre",
        ],
        image: "https://placehold.co/600x400/f1f5f9/475569?text=Partner+Logos", // Replaced PLACEHOLDER
        imageAlt: "Partner organization wall",
      },
      {
        eyebrow: "Our donors",
        title: "Thank you to those who give",
        accent: "Thank you",
        copy:
          "The Vision Foundation thrives because of generous donors who give time, belongings, and support.",
        points: [
          "Kevin Wilson", "Christophe Lavoie", "Renzo Castillo", "Maximus Trinchini",
          "Manny Trinchini", "Luc Parise", "Destiny Hull", "Jack Briggs",
          "Jan Nozewski", "Alex Nozewski", "Sarah Haddad", "Spencer Letourneau",
          "Justin Stringer", "Nick Maniatis", "Julia King", "Sonja Nilsson",
          "Lina Nilsson", "Dante Rozzi", "Caitlyn Batty", "Mike Potts",
          "Alexandra Potts", "Anne Mcgreevi", "Genesis Lazaro",
          "…and many others who prefer to remain anonymous.",
        ],
        image: "https://placehold.co/600x400/fff7ed/c2410c?text=Thank+You+Donors", // Used existing path or replace if it was also placeholder
        imageAlt: "Donor name plaque",
        flip: true,
      },
    ],
    footerCta: {
      title: "Want to contribute?",
      accent: "contribute",
      copy:
        "Bring clothes, books, or non-perishable food to our next collection day, or join a hand-to-hand distribution.",
      label: "Get involved",
      href: "/contact",
    },
  },

  "breaking-boundaries": {
    slug: "breaking-boundaries",
    hero: {
      bgImage: blog2, // This uses an imported image, not placeholder
      imagePosition: "center",
      bgSize: "cover",
      kicker: "Expansion • Growth • Excellence",
      title: "Breaking Boundaries: Our Journey Toward Nationwide Presence",
      subtitle:
        "From Montreal to Toronto: Building a Safer, Stronger Canada.",
      dateISO: "2025-10-15",
      readTimeMin: 6,
      tags: ["Growth", "Security", "Nationwide"],
      author: {
        name: "Vision Sécurité Team",
        avatar: "https://placehold.co/100x100/3244ba/ffffff?text=VS", // Use existing path or replace if it was placeholder
      },
    },
    lead: {
      eyebrow: "Our Expansion Journey",
      title: "Expanding with Purpose",
      accent: "expanding",
      copy:
        "As we continue to expand, our focus is on building a strong, reliable, and highly professional security team. We're investing in recruiting the right people, providing comprehensive training, and fostering a culture built on accountability, communication, and teamwork. By strengthening our leadership structure, maintaining consistent standards, and equipping our staff with the tools and knowledge they need, we ensure our security team grows with the company and delivers exceptional service at every site we serve.",
    },
    blocks: [
      {
        quote:
          "What began in Montreal, where our headquarters still stand, was more than just a starting point: it was our proving ground. It's where we perfected our operational model of compliance and reliability. From there, we expanded methodically across the Greater Montreal area, then into Quebec City and throughout the province, proving our strategies were ready to scale. With our strong reputation established in Quebec, we set our sights on Ontario as a deliberate, strategic move. We knew we couldn't just open an office; we had to import our high standards. We launched a dedicated six-month recruitment campaign, an intensive mobilization to ensure only the most qualified, compliant, and professional individuals joined our ranks.Today, we proudly provide services in the Greater Toronto Area and Ottawa. Our focus is on implementing the same proactive security strategies that built our name, protecting our partners' assets and ensuring their business continuity. We aren't just present in Ontario; we are actively working to raise the standards of service and provide genuine, measurable peace of mind.",
        cite: "Vision Team",
        image: ont_que,
        imageAlt: "Our Expansion Journey",
      },
      {
        eyebrow: "Focused Growth",
        title: "Concentrating Our Efforts on Quebec and Ontario",
        accent: "focused",
        copy:
          "Our Focused Growth strategy is deliberate. By concentrating our efforts on Quebec and Ontario, we commit to a depth of service that a wider-spread approach cannot match. These two provinces represent Canada's primary economic engines, each with a unique and rapidly evolving landscape of security risks. A one size fits all national model simply fails to address the hyper-local realities of managing a high-rise in Montreal versus a commercial complex in the GTA.This focus allows us to develop a nuanced understanding of the distinct regulatory environments, municipal bylaws, and specific threat profiles of each region. We don't just operate in these markets; we are deeply embedded in them.Furthermore, this concentration allows us to build the most reliable workforce in the industry. Our resources for recruitment, advanced training, and management oversight are not stretched thin. We invest heavily in our local teams, ensuring our agents are not only compliant with provincial standards but are also supported by a strong, local management structure. For our clients, this translates into superior reliability, faster operational response, and a security partner that truly understands their world.",
        image: canadatrain,
        imageAlt: "Focused Growth",
        flip: true,
      },
      {
        eyebrow: "Our Commitment",
        title: "Building a Safer Canada",
        accent: "commitment",
        copy:
          "Our commitment to building a safer Canada is rooted in a fundamental shift from reactive to proactive security. A reactive approach simply waits for an incident to occur: an alarm, a breach, or a loss. Our model, in contrast, is architected to prevent that incident from ever happening. This commitment means we function as strategic partners, not just as service providers. We are continuously developing and implementing strategies to proactively identify vulnerabilities before they can be exploited. This involves comprehensive risk assessments, close consultation with property managers and corporate leaders, and the intelligent integration of technology with our highly-trained on-site personnel. By understanding the specific operational risks of a high-rise condominium in Toronto or a commercial hub in Montreal, we can design a security posture that deters threats actively. Raising the standard of security across the country isn't a slogan for us: it is our core business model. It is a commitment to creating environments where our clients' assets, tenants, and operations can thrive, secure in the knowledge that their security partner is always one step ahead.",
        image: canada,
        imageAlt: "Safer Canada",
      },
    ],
    footerCta: {
      title: "Join Us in Making a Difference",
      accent: "join",
      copy:
        "Be a part of our expansion and help us build a safer Canada. Join our efforts in Ontario and Quebec today.",
      label: "Get Involved",
      href: "/contact",
    },
  },

  "building-the-next-generation": {
    slug: "building-the-next-generation",
    hero: {
      bgImage: blog4, // This uses an imported image, not placeholder
      imagePosition: "center",
      bgSize: "cover",
      kicker: "Building the Future of Security",
      title: "Building the Next Generation of Security Professionals",
      subtitle:
        "Our BSP-accredited security guard training program is reshaping the future of security in Quebec by raising the bar on professional standards and training.",
      dateISO: "2025-10-18",
      readTimeMin: 7,
      tags: ["Training", "Security", "Professional Development"],
      author: {
        name: "Vision Sécurité Team",
        avatar: "https://placehold.co/100x100/3244ba/ffffff?text=VS", // Replaced PLACEHOLDER
      },
    },

    lead: {
      eyebrow: "Building the Next Generation of Security Professionals",
      title: "Raising the Bar for Security Training",
      accent: "training",
      copy:
        "Over 18 months ago, we began building something we believe will change the future of security in Quebec: our very own BSP-accredited security guard training program. After identifying major flaws in how the course was traditionally taught, we committed nearly 1,000 hours of development and significant financial investment into creating a program that raises the bar for training. Our mission is simple—to ensure every security professional is equipped, confident, and prepared for the realities of the job.",
    },

    blocks: [
      {
        quote:
          "We don't just certify security officers. We prepare them for real-life scenarios with a program that is intentionally more challenging, ensuring that graduates are truly ready for the field.",
        cite: "Vision Sécurité Team",
        image: blog4,
        imageAlt: "Security training scenario",
      },
      {
        quote:
          "Our investment in training isn’t just about being the best in the industry—it’s about raising the bar for security everywhere we operate.",
        cite: "Christophe Lavoie",
        image: "https://placehold.co/600x400/fef3c7/b45309?text=Raising+The+Bar", // Replaced PLACEHOLDER
        imageAlt: "Graphic representing raising standards",
        flip: true,
      },
      {
        eyebrow: "Why we serve",
        title: "Stronger, Safer Security Workforce",
        accent: "security",
        copy:
          "We designed our BSP-accredited program with one goal in mind: to strengthen the labor force in the security industry. Unlike many existing courses, ours is intentionally more challenging, ensuring that graduates aren't just certified—they're truly ready to handle the wide range of situations they'll face in the field. While we continue to patiently await our license approval, we are confident that this course will become one of the most rigorous and effective training programs in the province.",
        image: workforceSafer,
        imageAlt: "Diverse group of security professionals",
        flip: true,
      },
      {
        eyebrow: "Preparing Our Workforce",
        title: "Investing in Tools and Training",
        accent: "tools",
        copy:
          "Six months ago, anticipating our license, we invested in a fully equipped classroom and training tools. Rather than letting them sit unused, we chose to immediately put them to work for our existing workforce. Today, we offer specialized in-house training modules, such as Intervention & De-escalation Training, Professional Etiquette & Customer Service Training, and more.",
        image: classroomTools,
        imageAlt: "Classroom setup for security training",
      },
      {
        quote:
          "The average knowledge score across the group before training was under 50%. This reinforced our belief that ongoing training is the most valuable investment we can make in our team.",
        cite: "Vision Sécurité Team",
        image: "https://placehold.co/600x400/ecfccb/4d7c0f?text=Knowledge+Score+Chart", // Replaced PLACEHOLDER
        imageAlt: "Security training session graph",
      },
      {
        eyebrow: "Professional Etiquette & Customer Service",
        title: "Training Beyond the Basics",
        accent: "etiquette",
        copy:
          "Our etiquette and customer service course emphasizes the importance of communication, respect, and approachability. Whether interacting with clients, tenants, or the general public, agents learn how to represent not only themselves but also the reputation of the entire industry. A well-trained officer can de-escalate conflict before it begins, simply by demonstrating composure and professionalism.",
        image: customerServiceTraining,
        imageAlt: "Customer service training session",
      },
    ],

    footerCta: {
      title: "Want to contribute?",
      accent: "contribute",
      copy:
        "Join us in our mission to raise the standards of security training. Become part of the solution—get involved with our program and help us build the next generation of security professionals.",
      label: "Get involved",
      href: "/contact",
    },
  },

  "stories-from-the-field": {
    slug: "stories-from-the-field",
    hero: {
      bgImage: blog3, // This uses an imported image, not placeholder
      imagePosition: "center",
      bgSize: "cover",
      kicker: "Real Problems • Real Solutions",
      title: "Real Problems, Real Solutions: Stories from the Field",
      subtitle:
        "Real-world security operations that demonstrate our commitment to excellence, rapid response, and proactive protection. These are the defining moments that built our reputation.",
      dateISO: "2025-09-01",
      readTimeMin: 5,
      tags: ["Security", "Stories", "Real-life Experience"],
      author: {
        name: "Vision Sécurité Team",
        avatar: "https://placehold.co/100x100/3244ba/ffffff?text=VS", // Replaced PLACEHOLDER
      },
    },
    lead: {
      eyebrow: "Case Studies & Real Operations",
      title: "When Training Meets Reality",
      accent: "solutions",
      copy:
        "In the security industry, theory means nothing without proven results. The following case studies represent critical moments where our team's extensive training, strategic planning, and decisive action prevented significant threats, protected lives, and secured property.\n\nThese aren't fictional scenarios or hypothetical situations. These are real operations conducted by Vision Security personnel — documented interventions that demonstrate our operational philosophy: prevention through preparation, rapid response through experience, and excellence through accountability.\n\nFrom coordinating emergency deployments to managing high-risk interventions, these stories showcase the caliber of professionals we deploy and the level of service our clients receive.",
    },
    blocks: [
      {
        quote:
          "Dangerous criminal organizations we've helped the police disrupt. Our team’s vigilance led to the capture of some of the most dangerous criminals targeting local businesses and communities.",
        cite: "Vision Sécurité Team",
        image: "https://placehold.co/600x400/e5e7eb/1f2937?text=Crime+Disruption", // Replaced PLACEHOLDER
        imageAlt: "Criminal organizations disrupted",
      },
      {
        quote:
          "Challenges and risks our agents have faced head-on during high-profile events. From large-scale public events to private VIP protection, our agents have been trained to handle the most challenging situations.",
        cite: "Vision Sécurité Team",
        image: "https://placehold.co/600x400/d1fae5/065f46?text=Event+Security", // Replaced PLACEHOLDER
        imageAlt: "High-profile event security",
        flip: true,
      },
      {
        quote:
          "Unforgettable experiences that showcase the resilience, courage, and dedication of our team. These stories reflect our commitment to maintaining safety and order in the most challenging environments.",
        cite: "Vision Sécurité Team",
        image: "https://placehold.co/600x400/bfdbfe/1e40af?text=Agent+Dedication", // Replaced PLACEHOLDER
        imageAlt: "Agent in action",
      },
      {
        eyebrow: "Case Study #1: Emergency Deployment",
        title: "Securing the F1 Grand Prix on Crescent Street",
        accent: "test",
        copy:
          "Before our company was officially established, our CEO was already deeply rooted in the security industry. He served as a Security Supervisor and Head of Security for multiple organizations, and even worked as a bodyguard for some of the world's most famous celebrities. Over the years, he built strong connections and earned a trusted reputation in the field.\n\nOne day, everything changed.\n\nAt 6 p.m., our CEO received an urgent call from his best friend, now our Head of Security, Mr. Chase Thomas, a highly respected expert in the industry. A major security company had pulled out of the Grand Prix on Crescent Street at the very last minute, leaving the event without the 60 agents it needed for the next morning. It was a crisis, and they had less than 12 hours to solve it.\n\nMr. Trinchini and Mr. Thomas worked through the entire night, calling every agent they knew. By morning, they had accomplished the impossible: all 60 positions were filled.\n\nBut the challenge didn't end there. Since there was no supervisor or dispatch team available to oversee the agents, both men took charge on-site. They worked nearly 80 hours straight, without rest, to ensure the event ran safely and smoothly. They even refused to take any profit, choosing instead to ensure every agent, many of whom were close friends and associates, was paid fairly.\n\nThat moment was the spark that ignited everything.\n\nShortly after the Grand Prix, security companies began reaching out, asking to subcontract agents through them. The demand grew, their reputation spread, and what started as an overnight emergency operation became the foundation of Vision Security as it exists today.\n\nAnd the rest is history.",
        image: f1Crescent,
        imageAlt: "F1 Grand Prix security",
        flip: true,
      },
      {
        eyebrow: "Case Study #2: Crime Prevention",
        title: "Rapid Response to Targeted Crime Wave",
        accent: "risk",
        copy:
          "We recently received an urgent call from a new client whose business was being targeted by organized criminals. This wasn't an isolated case — several businesses in the same area had contacted us with similar concerns. Recognizing a clear pattern and an escalating threat, we immediately began strategizing, coordinating resources, and developing a custom security solution for the affected zone.\n\nGiven the high threat to both life and property, we allocated significant resources to the operation. Communication with police, detectives, and community partners became essential as we gathered intelligence and worked collaboratively to prevent further criminal activity.\n\nOne evening, at one of the locations under our protection, the situation escalated dramatically.\n\nDuring a routine patrol, our on-site security officer, Shuaib Asubiaro, a 10-year veteran of the Nigerian Armed Forces, observed two masked criminals attempting to fire-bomb the establishment. Thanks to his extensive tactical training and quick instincts, Shuaib reacted instantly.\n\nHe sprinted toward the perpetrators, chasing them off before they could fully ignite the device, preventing what could have been a devastating attack. Without hesitation, he then grabbed his fire extinguisher, neutralized the flames, and secured the area — effectively saving the business from severe damage or total loss.\n\nShuaib's professionalism, bravery, and rapid decision-making prevented an event that could have resulted in catastrophic financial and safety consequences for our client, nearby businesses, and the public.\n\nFollowing the incident, our team increased patrol frequency in the entire zone, implemented a specialized high-risk response unit for that sector, provided detailed reports and evidence to police investigators, and conducted risk assessments and strengthened prevention measures for all clients in the area.\n\nAs a direct result of these collective efforts, criminal activity in that district dropped significantly, and multiple businesses expressed their gratitude for the heightened sense of safety and security.\n\nThis operation stands as a powerful example of what happens when training, preparedness, and decisive action come together — and a reminder of the level of commitment our team brings to every client, every shift, and every crisis.",
        image: docuCriminals,
        imageAlt: "Security footage documentation",
        flip: true,
      },

      {
        eyebrow: "Case Study #3: High-Risk Intervention",
        title: "Coordinated Response: Fifteen Squatter Removals in One Night",
        accent: "risk",
        copy:
          "One of our clients contacted us late one evening with an urgent request for a security presence at a downtown Montreal building. The risks were unclear, so a standard security agent was dispatched to assess the situation. What unfolded that night was far from routine.\n\nDuring his patrol, the agent was threatened at knifepoint and encountered an alarming and unexpected case of organized squatting. After coordinating with the police, our priority became ensuring the safety of the building, the residents, and our personnel. We immediately contacted the client to inform them of the severity of the situation and advise on next steps.\n\nAt that moment, the solution became clear.\n\nWe dispatched our Head of Security, Chase Thomas, along with another experienced agent, to re-evaluate the premises. Upon arrival, Chase reported that this was one of the most serious squatter-related situations he had ever encountered, far more dangerous and extensive than initially believed.\n\nConcerned for his team's safety and located nearby, our CEO quickly put on his protective gear and headed to the scene to fully understand the risks his agents were facing.\n\nWorking together on-site, Maximus and Chase devised an immediate intervention plan. They successfully removed five squatters from the premises without any physical confrontation, confiscated multiple weapons, and relayed all intelligence to law enforcement. Once the strategy was established, our CEO returned home while Chase and the second agent continued the mission.\n\nChase instructed the agent to record the interventions as he handled them directly. Equipped with his own protective gear and backed by years of frontline experience, he proceeded with confidence and professionalism.\n\nThat night, Chase removed 15 additional squatters, clearing the building entirely. Even the police expressed their respect for the efficiency and composure demonstrated during the operation.\n\nThis incident stands as one of the most successful deployments of our intervention team, a powerful reminder that preparation, leadership, and decisive action are what deliver real results.",
        image: squattersIntervention,
        imageAlt: "High-risk intervention operation",
      },

      {
        eyebrow: "Case Study #4: Mass Event Security",
        title: "Igloofest New Year's Eve: Managing 70,000+ Attendees",
        accent: "crowd",
        copy:
          "During the New Year's Eve Igloofest event, our team successfully managed the largest crowd we have ever handled. The Old Port was packed with over 70,000 people, with nearly 40,000 attendees concentrated in our designated area alone.\n\nAn operation of this scale required meticulous planning, constant on-the-ground coordination, and a highly trained team capable of responding to rapidly evolving situations. Despite being understaffed, our personnel demonstrated resilience, professionalism, and teamwork of the highest caliber.\n\nThroughout the night, our team conducted over 20 interventions, all handled efficiently and without major incident. Every action was carried out with the safety of attendees as the top priority, and the event concluded smoothly, a testament to the dedication and expertise of our agents.\n\nThis New Year's Eve deployment stands as one of our most impressive achievements to date, showcasing our ability to deliver results under pressure and manage large-scale operations with precision.",
        image: iglofestCrowd,
        imageAlt: "Crowd control at Igloofest",
      },
    ],
    footerCta: {
      title: "Experience the Difference",
      accent: "contribute",
      copy:
        "These stories represent our standard of service. If you're looking for a security partner with proven operational excellence and a track record of real-world results, we're ready to serve you.",
      label: "Request a Consultation",
      href: "/contact",
    },
  },
};

export default BLOG_DATA;
